import React from "react";
import { Route, Routes } from "react-router-dom";
import Main from "./Main";
import Admin from "./Admin";

function App() {
  return (
    <div className="page">
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </div>
  );
}

export default App;
